export default "__VITE_ASSET__D$PFDoNg__"